import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(() => ({
    root: {
        width: '100%',
        height: '100%',
    },
    dBlock: {
        display: 'block',
    },
}));

export default useStyles;